import { render, staticRenderFns } from "./chanelChart.vue?vue&type=template&id=0297cddd&"
import script from "./chanelChart.vue?vue&type=script&lang=js&"
export * from "./chanelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports